import type { PropsWithChildren } from "react";
import type { Props } from "./DocumentViewsGridContext";
import { DocumentViewsGridContext } from "./DocumentViewsGridContext";

export const DocumentViewsGridContextProvider = ({ showFilePreview, children }: PropsWithChildren<Props>) => {
  return <DocumentViewsGridContext value={{ showFilePreview }}>{children}</DocumentViewsGridContext>;
};
